import {createFeatureSelector, createSelector} from '@ngrx/store';
import { FeatureState, toggleFeatureFeatureKey } from './toggle-feature.reducer';

const selectToggleFeatureState = createFeatureSelector<FeatureState>(toggleFeatureFeatureKey);

export const selectFeatureStateForm = createSelector(
    selectToggleFeatureState, (state) => ({...state})
);
